export default __webpack_public_path__ + "static/media/teodor-drobota-2400.47e74aec.jpg";